<template>
  <section>
    <e-w-b-home-page v-if="ewbTenant"></e-w-b-home-page>
    <p-o-d-home-page v-if="podTenant"></p-o-d-home-page>
  </section>
</template>

<script>
import EWBHomePage from '@/components/EWBHomePage'
import PODHomePage from '@/components/PODHomePage'

export default {
  name: 'HomePage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  components: {PODHomePage, EWBHomePage},
  computed: {
    ewbTenant () {
      return this.$store.state.ewbTenant
    },
    podTenant () {
      return this.$store.state.podTenant
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

a, .medium, .small, .huge {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue